import Vue from "vue";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.tz.setDefault("Asia/Seoul");

const emptyDate = () => {
  return "";
};

Vue.mixin({
  methods: {
    YYYYMMDDHHmmDate(val) {
      if (!val) {
        return emptyDate();
      }
      return dayjs(val).format("YYYY-MM-DD HH:mm");
    },

    KOREAYYYYMMDDDate(val) {
      if (!val) {
        return emptyDate();
      }

      const koreaE = ["(일)", "(월)", "(화)", "(수)", "(목)", "(금)", "(토)"];
      return dayjs(val).format("YYYY년 MM월 DD일 ") + koreaE[dayjs(val).day()];
    },

    KOREAYYYYMMDDEEHHMMDate(val) {
      if (!val) {
        return emptyDate();
      }

      const koreaE = ["(일)", "(월)", "(화)", "(수)", "(목)", "(금)", "(토)"];
      return (
        dayjs(val).format("YYYY년 MM월 DD일 ") +
        koreaE[dayjs(val).day()] +
        dayjs(val).format(" HH시 mm분")
      );
    },

    PRINTYYMMDDDate(val) {
      if (val === null || val === undefined || val === "") {
        return "";
      }
      return dayjs(val).format("YYYY년 MM월 DD일");
    }
  }
});
